import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { ToastService } from '../shared/toast/toast.service';

const LOGIN_ENDPOINT = '/usuario/auth';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const toast = inject(ToastService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const isAuthError = err.status === 401 || err.status === 403;
      const isLoginRequest = req.url.includes(LOGIN_ENDPOINT);
      if (isAuthError && !isLoginRequest && auth.isAuthenticated()) {
        auth.logout();
        toast.error('Sesión vencida', 'Tu sesión ha expirado. Vuelve a ingresar.');
        router.navigate(['/login']);
      }
      return throwError(() => err);
    })
  );
};
